const TEXT = {
    APPLY_STEP2_TEXT_1:"恭喜您，您的代理资质已通过! ",
    APPLY_STEP2_TEXT_2:"恭喜您，您的申请已经成功提交，请等待系统审核! ",
};
export {
	TEXT
}












// WEBPACK FOOTER //
// ./src/config/page/cn/apply/step2/index.js